import { render } from "./CIS-Blockquote.vue?vue&type=template&id=525d8e4e"
import script from "./CIS-Blockquote.vue?vue&type=script&lang=js"
export * from "./CIS-Blockquote.vue?vue&type=script&lang=js"

import "./CIS-Blockquote.vue?vue&type=style&index=0&id=525d8e4e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__